import styled from "styled-components/macro";

export const StyledPrompt = styled.div`
  background: var(--container-color);
  color: var(--grey-1);
  border-radius: 30px;
  width: 412px;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;

  .edit-action {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translate(0, -50%);
    border-radius: 30px;
    cursor: pointer;

    svg {
      path {
        fill: var(--grey-1);
        opacity: 1;
      }
    }

    &:hover {
      background: var(--grey-3);
    }
  }
  svg {
    path {
      fill: var(--icon-button-color);
      opacity: var(--icon-button-opacity);
    }
  }
`;

export const StyledMaybeList = styled.div`
  width: 478px;
  float: left;
  overflow-y: auto;
  ${({ listHeight }) => listHeight && `max-height: ${listHeight}px`};
  padding-left: 20px;
  padding-bottom: 20px;
  margin-top: -138px;
  margin-left: -10px;
  ${({ listHeight }) => listHeight && `min-height: ${listHeight}px`};
  overflow-x: hidden;
`;

export const StyledRightColumn = styled.div`
  width: 300px;
  float: right;
  margin-top: -98px;

  ${({ editing }) => editing && "margin-top: -50px"};
`;

export const StyledLoader = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--container-color);
  position: absolute;
  float: right;
  margin-left: 450px;
  margin-top: -47px;
  padding: 7px;
  cursor: pointer;

  svg {
    position: absolute;
    top: 9px;
    right: 5px;
    path {
      fill: var(--icon-button-fill);
      opacity: var(--icon-button-opacity);
    }
  }

  ${({ $loading }) => ($loading ? "animation-name: spinIt; animation-duration: 1s;" : "")}

  @keyframes spinIt {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  i {
    color: #888;
    position: absolute;
    top: 7px;
    left: 11px;
    z-index: 3;

    &.fa-pause {
      left: 10px;
    }
  }

  &:hover {
    background: var(--container-color-2);
  }
`;

export const StyledPromptLoaderArea = styled.div`
  width: 482px;
`;

export const StyledMaybeListContainer = styled.div`
  overflow: hidden;
  ${({ listHeight }) => listHeight && `height: ${listHeight - 120}px`};
  display: inline-block;
  padding-left: 10px;
  margin-left: -10px;
`;

export const StyledSubBrainform = styled.div`
  width: 455px;
  background: var(--container-color);
  padding: 15px;
  display: inline-block;
  border-radius: 15px;
  margin-bottom: 20px;

  textarea {
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 8px;
  }

  label {
    font-size: 15px;
  }

  button {
    float: right;
  }

  div:nth-child(2) {
    padding-top: 0;
  }

  div a.delete {
    width: 20px;
    position: absolute;
    top: 8px;
    right: 1px;
    opacity: 0.5;
    path {
      fill: var(--icon-button-fill);
    }
  }
`;
